// @ts-nocheck
// eslint-disable
// This file is generated by create-validator-ts
import Ajv from "ajv";
import * as apiTypes from "./TemplateListDTO";

export const SCHEMA = {
  $schema: "http://json-schema.org/draft-07/schema#",
  $ref: "#/definitions/TemplateListDTO",
  definitions: {
    TemplateListDTO: {
      type: "object",
      properties: {
        status: {
          type: "string",
          const: "ok",
        },
        type: {
          type: "string",
          const: "data",
        },
        data: {
          type: "object",
          properties: {
            Passes: {
              type: "array",
              items: {
                $ref: "#/definitions/TemplateItem",
              },
            },
            PagingData: {
              $ref: "#/definitions/PagingDataDTO",
            },
          },
          required: ["Passes", "PagingData"],
          additionalProperties: false,
        },
      },
      required: ["status", "type", "data"],
      additionalProperties: false,
    },
    TemplateItem: {
      type: "object",
      properties: {
        PassInfo: {
          $ref: "#/definitions/PartialPassInfoDTO",
        },
        PassBeacon: {
          type: "array",
          minItems: 0,
          maxItems: 0,
        },
        PassBarcode: {
          anyOf: [
            {
              $ref: "#/definitions/PartialPassBarcode",
            },
            {
              type: "object",
              additionalProperties: false,
            },
          ],
        },
        PassStyle: {
          $ref: "#/definitions/PartialPassStyle",
        },
        PassHeader: {
          type: "array",
          items: {
            $ref: "#/definitions/PassPartialTextField",
          },
        },
        PassPrimary: {
          type: "array",
          items: {
            $ref: "#/definitions/PassPartialTextField",
          },
        },
        PassSecondary: {
          type: "array",
          items: {
            $ref: "#/definitions/PassPartialTextField",
          },
        },
        PassAuxiliary: {
          type: "array",
          items: {
            $ref: "#/definitions/PassPartialTextField",
          },
        },
        PassBack: {
          type: "array",
          items: {
            $ref: "#/definitions/PassPartialBackField",
          },
        },
        PassLocation: {
          type: "array",
          items: {
            $ref: "#/definitions/PartialPassLocation",
          },
        },
      },
      required: [
        "PassInfo",
        "PassBeacon",
        "PassBarcode",
        "PassStyle",
        "PassHeader",
        "PassPrimary",
        "PassSecondary",
        "PassAuxiliary",
        "PassBack",
        "PassLocation",
      ],
      additionalProperties: false,
    },
    PartialPassInfoDTO: {
      type: "object",
      properties: {
        Description: {
          type: "string",
        },
        LogoText: {
          type: ["string", "null"],
        },
        OrganizationName: {
          type: "string",
        },
        PassInfoId: {
          type: "number",
        },
        SerialNumber: {
          type: ["number", "string", "null"],
        },
        iTunesIdentifier: {
          type: ["string", "null"],
        },
      },
      required: [
        "Description",
        "LogoText",
        "OrganizationName",
        "PassInfoId",
        "SerialNumber",
        "iTunesIdentifier",
      ],
      additionalProperties: false,
    },
    PartialPassBarcode: {
      type: "object",
      properties: {
        PassInfoId: {
          type: "number",
        },
        UseBarcode: {
          type: "boolean",
        },
        BarcodeFormatId: {
          type: "number",
        },
        MessageEncodingId: {
          type: "number",
        },
        BarcodeMessage: {
          type: "string",
        },
        BarcodeAltText: {
          type: ["string", "null"],
        },
      },
      required: [
        "PassInfoId",
        "UseBarcode",
        "BarcodeFormatId",
        "MessageEncodingId",
        "BarcodeMessage",
        "BarcodeAltText",
      ],
      additionalProperties: false,
    },
    PartialPassStyle: {
      type: "object",
      properties: {
        PassInfoId: {
          type: "number",
        },
        ImageStyleId: {
          type: "string",
        },
        Background: {
          type: "string",
        },
        Foreground: {
          type: "string",
        },
        Label: {
          type: "string",
        },
        LogoUrl: {
          type: ["string", "null"],
        },
        IconUrl: {
          type: "string",
        },
        StripUrl: {
          type: ["string", "null"],
        },
        ThumbnailUrl: {
          type: ["string", "null"],
        },
        BackgroundUrl: {
          type: ["string", "null"],
        },
        FooterUrl: {
          type: ["string", "null"],
        },
        TransitType: {
          type: "string",
        },
      },
      required: [
        "PassInfoId",
        "ImageStyleId",
        "Background",
        "Foreground",
        "Label",
        "LogoUrl",
        "IconUrl",
        "StripUrl",
        "ThumbnailUrl",
        "BackgroundUrl",
        "FooterUrl",
        "TransitType",
      ],
      additionalProperties: false,
    },
    PassPartialTextField: {
      type: "object",
      properties: {
        PassInfoId: {
          type: "number",
        },
        PassFieldId: {
          type: "number",
        },
        Value: {
          type: ["string", "null"],
        },
        Key: {
          type: ["string", "null"],
        },
        Label: {
          type: ["string", "null"],
        },
        AlignmentId: {
          type: ["number", "null"],
        },
        ChangeMessage: {
          type: ["string", "null"],
        },
        TypeId: {
          type: "number",
        },
      },
      required: [
        "PassInfoId",
        "PassFieldId",
        "Value",
        "Key",
        "Label",
        "AlignmentId",
        "TypeId",
      ],
      additionalProperties: false,
    },
    PassPartialBackField: {
      type: "object",
      properties: {
        PassInfoId: {
          type: "number",
        },
        PassBackId: {
          type: "number",
        },
        Value: {
          type: ["string", "null"],
        },
        Key: {
          type: ["string", "null"],
        },
        Label: {
          type: ["string", "null"],
        },
        AlignmentId: {
          type: ["number", "null"],
        },
        ChangeMessage: {
          type: ["string", "null"],
        },
      },
      required: [
        "PassInfoId",
        "PassBackId",
        "Value",
        "Key",
        "Label",
        "AlignmentId",
      ],
      additionalProperties: false,
    },
    PartialPassLocation: {
      type: "object",
      properties: {
        Latitude: {
          type: "number",
        },
        Longitude: {
          type: "number",
        },
        RelevantText: {
          type: "string",
        },
        LocationName: {
          type: "string",
        },
      },
      required: ["Latitude", "Longitude"],
      additionalProperties: false,
    },
    PagingDataDTO: {
      type: "object",
      properties: {
        Page: {
          type: "number",
        },
        PageSize: {
          type: "number",
        },
        TotalData: {
          type: "number",
        },
        TotalPages: {
          type: "number",
        },
      },
      required: ["Page", "PageSize", "TotalData", "TotalPages"],
      additionalProperties: false,
    },
  },
};
const ajv = new Ajv({ removeAdditional: true }).addSchema(SCHEMA, "SCHEMA");
export function validateTemplateListDTO(
  payload: unknown
): apiTypes.TemplateListDTO {
  /** Schema is defined in {@link SCHEMA.definitions.TemplateListDTO } **/
  const validator = ajv.getSchema("SCHEMA#/definitions/TemplateListDTO");
  const valid = validator(payload);
  if (!valid) {
    const error = new Error(
      "Invalid TemplateListDTO: " +
        ajv.errorsText(validator.errors, { dataVar: "TemplateListDTO" })
    );
    error.name = "ValidationError";
    throw error;
  }
  return payload;
}

export function isTemplateListDTO(
  payload: unknown
): payload is apiTypes.TemplateListDTO {
  try {
    validateTemplateListDTO(payload);
    return true;
  } catch (error) {
    return false;
  }
}
